/* eslint-disable no-case-declarations */

import { Gutter, Icon, Link } from '@common/components';
import React from 'react';
import { HistoryInfoFragmentFragment } from '@common/graphql';
import { buildDialogUrl } from '@common/services';

const renderSingleAttachment = (
  id: string | undefined,
  fileName: string | undefined
): React.ReactElement => {
  if (fileName && !id) {
    return (
      <Gutter fit className="value-after" size="xs" direction="right">
        {fileName}
      </Gutter>
    );
  }

  if (fileName && id) {
    const viewDrawerUrl = buildDialogUrl('document-preview-drawer', {
      props: {
        blobId: id,
      },
    });

    return (
      <Link to={viewDrawerUrl} style={{ marginRight: 4 }}>
        <Icon icon="paperclipVertical" kind="light" color="midnightRegular" />
        <Gutter fit size="xs" direction="left">
          <b>{fileName}</b>
        </Gutter>
      </Link>
    );
  }

  return <span className="value-after-none">None</span>;
};

export type RenderChange = (
  history: NonNullable<HistoryInfoFragmentFragment['changes']>[number]
) => React.ReactElement | undefined;

export const historyRenderChange: RenderChange = (change: {
  type?: string | null;
  dataAfter?: unknown | null;
  dataBefore?: unknown | null;
  fieldName: string;
  valueBefore?: string | null;
  valueAfter?: string | null;
}) => {
  switch (change.type) {
    case 'link':
      const linkAfter = change.dataAfter as Record<string, string> | undefined;
      return (
        <div className="mb-4">
          {change.fieldName}
          {': '}
          <Link target="blank" to={linkAfter?.url as string}>
            {linkAfter?.code}
          </Link>
        </div>
      );
    case 'attachment':
      const attBefore = (change.dataBefore || []) as string[];
      const attAfter = (change.dataAfter || { id: [], name: [] }) as {
        id: string[];
        name: string[];
      };

      return (
        <>
          <div className="mb-4">
            <span className="field-name">{`${change.fieldName}: `}</span>
            <span className="value-before">{attBefore.join(', ')}</span>
            {Array.isArray(attAfter.id)
              ? attAfter.id.map((id, index) => {
                  const fileName = attAfter.name?.[index];
                  return renderSingleAttachment(id, fileName);
                })
              : (() => {
                  const id = attAfter.id as string | undefined;
                  const fileName = attAfter.name as unknown as
                    | string
                    | undefined;

                  return renderSingleAttachment(id, fileName);
                })()}
          </div>
        </>
      );
    default:
      return (
        <div className="mb-4">
          <span className="field-name">{`${change.fieldName}: `}</span>
          <span className="value-before">{change.valueBefore ?? ''}</span>
          <span
            className={`value-after${change.valueBefore ? ' addition' : ''}`}
          >
            {` ${change.valueAfter ?? 'None'}`}
          </span>
        </div>
      );
  }
};
